import React from 'react';
import Button from '../Components/Button';
import Layout from '../Components/Layout/Layout';
import Slider from '../Components/Slider/Slider';
import VideoAnima from '../Components/VideoAnima/VideoAnima';
import Combinacoes from '../Components/Combinacoes/Combinacoes';
import SectionPromo from '../Components/Sections/SectionPromo/SectionPromo';
import SectionPromo2 from '../Components/Sections/SectionPromo/SectionPromo2';
import SectionCombo from '../Components/Sections/SectionCombo/SectionCombo';
import SliderProdutos from '../Components/SliderProdutos/SliderProdutos';
import SectionCupom from '../Components/Sections/SectionCupom/SectionCupom';
import SectionApp from '../Components/Sections/SectionApp/SectionApp';
import MapaUnidades from '../Components/MapaUnidades/MapaUnidades';
import Parceiros from '../Components/Parceiros/Parceiros.js';

function Home() {
  return (
    <Layout>
      <Slider />
      <Combinacoes />
      <Parceiros />
      {/* <VideoAnima /> */}
      <SectionPromo />
      <SectionCombo />
      {/* <SectionPromo2 /> */}
      <SliderProdutos />
      {/* <SectionCupom /> */}
      <SectionApp />
      <MapaUnidades />
    </Layout>
  );
}

export default Home;
